Object.defineProperty(exports, "__esModule", { value: true });
exports.getVueLibraryName = exports.getSlotsPropertyName = void 0;
function getSlotsPropertyName(vueVersion) {
    return vueVersion < 3 ? '$scopedSlots' : '$slots';
}
exports.getSlotsPropertyName = getSlotsPropertyName;
function getVueLibraryName(vueVersion) {
    return vueVersion < 2.7 ? '@vue/runtime-dom' : 'vue';
}
exports.getVueLibraryName = getVueLibraryName;
//# sourceMappingURL=shared.js.map